import React, { useState } from 'react';
import MediaPanel from './components/MediaPanel';
import SearchControls from './components/SearchControls';
import RecordPanel from './components/RecordPanel';
import Login from './components/Login';
import { Heading, Flex } from '@chakra-ui/react';
import { DragHandleIcon } from '@chakra-ui/icons'
import SplitPane, { Pane, SashContent } from "split-pane-react";
import 'split-pane-react/esm/themes/default.css'


function Layout(props) {
    const {
        filteredData,
        agentFilter,
        setAgentFilter,
        queueFilter,
        setQueueFilter,
        phoneFilter,
        setPhoneFilter,
        subjectFilter,
        setSubjectFilter,
        emailFilter,
        setEmailFilter,
        selectedItem,
        setSelectedItem,
        selectedMediaType,
        setSelectedMediaType,
        mediaBody,
        recordLoading,
        mediaLoading,
        setMediaLoading,
        channelFilter,
        setChannelFilter,
        fetchDynamoRecords,
        selectedDates,
        setSelectedDates,
        signOut,
        signIn,
        isAuthenticated,
        alias,
        setAlias
    } = props;

    const [sizes, setSizes] = useState([
        '50%',
        '50%',
    ]);

    if(isAuthenticated) {
        return (
            <Flex flexDirection="column" height='99vh'>
                <Flex p="10px" flexDirection='column' width='100%' alignItems="center" >
                    <Heading size='md'>Interaction Search</Heading>
                    <SearchControls
                        channelFilter={channelFilter}
                        setChannelFilter={setChannelFilter}
                        fetchDynamoRecords={fetchDynamoRecords}
                        selectedDates={selectedDates}
                        setSelectedDates={setSelectedDates}
                        signOut={signOut}
                        agentFilter={agentFilter}
                        setAgentFilter={setAgentFilter}
                        queueFilter={queueFilter}
                        setQueueFilter={setQueueFilter}
                        phoneFilter={phoneFilter}
                        setPhoneFilter={setPhoneFilter}
                        subjectFilter={subjectFilter}
                        setSubjectFilter={setSubjectFilter}
                        emailFilter={emailFilter}
                        setEmailFilter={setEmailFilter}
                    />
                </Flex>
                <Flex flexDirection="row" width="99vw" height="95vh">
                    <SplitPane
                        split='vertical'
                        sizes={sizes}
                        onChange={setSizes}
                        resizerSize={1}
                        sashRender={(index, active) => (
                            <SashContent style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'center', backgroundColor: "rgba(0,0,0,.1)" }}>
                                <DragHandleIcon boxSize={3} bg='white' />
                            </SashContent>
                        )}
                    >
                        <Pane minSize={50} maxSize='90%'>   
                
                            <Flex p='10px' height="90%" mt="15px" overflowX="scroll" overflowY="scroll">
                                <RecordPanel
                                    filteredData={filteredData}
                                    setMediaLoading={setMediaLoading}
                                    setSelectedMediaType={setSelectedMediaType}
                                    setSelectedItem={setSelectedItem}
                                    recordLoading={recordLoading} 
                                />
                            </Flex>
                        </Pane>
                        <Pane minSize={50} maxSize='90%'>
                            <Flex height="90%" m="1vh" p='10px' justifyContent="center" overflowX="scroll">
                                <MediaPanel mediaBody={mediaBody} mediaLoading={mediaLoading} selectedMediaType={selectedMediaType} selectedItem={selectedItem} />
                            </Flex>
                        </Pane>
                    </SplitPane>
                </Flex>
            </Flex>
        );
    } else {
        return (
           <Login signIn={signIn} alias={alias} setAlias={setAlias}/>
        );
    }
}

export default Layout;
